import React from "react";
import { technologies } from "../../../data/technologies";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { getProjectLink } from "../../../utils/functions";

import "./styles.css";

const Project = ({ project }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const projectOrder = String(project.order).padStart(2, "0");

  return (
    <div className="project-container" onClick={() => navigate(getProjectLink(project))}>
      <div className="project-image-container">
        <img src={`${project.assetFolder}${project.assetLogo}`} alt={t(project?.titleKey)} />
      </div>

      <div className="project-content-container">
        <div className="project-headline-container">
          <span className="project-order-label">{projectOrder}</span>
          <div className="project-title-container">
            <span>{t(project.titleKey)}</span>
          </div>
          <span className="project-arrow">→</span>
        </div>

        <div className="project-about-container">
          <span>{t(project?.shortDescriptionKey)}</span>
        </div>

        <div className="project-title-tecnologies-container">
          {project.techs.map((techKey, index) => {
            const tech = technologies.find((t) => t.key === techKey);

            return tech ? (
              <div
                className="project-tech-pill"
                key={`${project.slug}-${techKey}-${index}`}
                style={{
                  "--tech-soft": tech.softColor,
                  "--tech-accent": tech.accentColor,
                }}
              >
                <span className="project-tech-pill-icon">
                  <img
                    src={`/assets/technologies/${tech.icon}`}
                    alt={tech.name}
                    title={tech.name}
                    style={{ height: 14, width: "auto" }}
                  />
                </span>
                <span className="project-tech-pill-label">{tech.name}</span>
              </div>
            ) : null;
          })}
        </div>
      </div>
    </div>
  );
};

export default Project;
